import React from 'react';
import ForecastCashComponent from './ForecastCashComponent';
const ForecastCashForm = ({ formikProps }) => {
    return React.createElement(ForecastCashComponent, { formikProps: formikProps });
};
export default ForecastCashForm;
